export * from './entity-details';